import type { RunSummary } from "./types.js";

type AppointmentLead = Pick<RunSummary, "address" | "sellerName"> & { timezone: string };

function streetLabel(address: string): string {
  return address.split(",")[0]?.trim() || "the property";
}

export function appointmentReminderSendAt(appointmentAt: string, now = new Date()): string | null {
  const appointment = new Date(appointmentAt).getTime();
  if (!Number.isFinite(appointment) || appointment <= now.getTime()) return null;
  const remaining = appointment - now.getTime();
  if (remaining > 26 * 3600000) return new Date(appointment - 24 * 3600000).toISOString();
  if (remaining > 3 * 3600000) return new Date(appointment - 2 * 3600000).toISOString();
  return now.toISOString();
}

export function buildAppointmentReminderMessage(run: AppointmentLead, appointmentAt: string): string {
  const name = run.sellerName?.trim().split(/\s+/)[0];
  const greeting = name ? `Hi ${name}, this is` : "Hi, this is";
  const date = new Intl.DateTimeFormat("en-US", {
    timeZone: run.timezone,
    weekday: "long",
    month: "short",
    day: "numeric"
  }).format(new Date(appointmentAt));
  const time = new Intl.DateTimeFormat("en-US", {
    timeZone: run.timezone,
    hour: "numeric",
    minute: "2-digit"
  }).format(new Date(appointmentAt));
  return `${greeting} Hope, an automated assistant with Middle America Homes. Reminder: your appointment with our team about ${streetLabel(run.address)} is ${date} at ${time}. Reply here if you need to reschedule. Reply STOP to opt out.`;
}
